import { connect } from 'react-redux';

import { getCurrentRepository } from 'src/selectors/repository-selectors';
import { BucketState } from 'src/types/state';

import FullCommitLink from '../components/full-commit-link';

const mapStateToProps = (state: BucketState) => {
  const { hash } = state.repository.source.section;
  const repository = getCurrentRepository(state);
  const repositoryFullSlug = repository ? repository.full_name : '';

  return { hash, repositoryFullSlug };
};

export default connect(mapStateToProps)(FullCommitLink);
